export default __webpack_public_path__ + "static/media/logo.44d6f9d1.svg";